import {GRADE_FROM_BAND} from './grades';
import type {Band} from './economy';

export type DashboardLook='adventure'|'studio';
// Review rollout: parents can opt a practice learner in; grade defaults stay off.
export const STUDIO_GRADE_DEFAULT_ENABLED=false;
export function dashboardLook(student:{grade?:number|null;band:Band;dashboard_look?:DashboardLook|null},gradeDefaultEnabled:boolean=STUDIO_GRADE_DEFAULT_ENABLED):DashboardLook {
  if(student.dashboard_look==='studio'||student.dashboard_look==='adventure')return student.dashboard_look;
  return gradeDefaultEnabled&&(student.grade??GRADE_FROM_BAND[student.band])>=4?'studio':'adventure';
}
export const STUDIO_ACCENTS=['teal','orange','blue','plum'] as const;
export const STUDIO_BADGES=['circle','diamond','bolt','peak'] as const;
export interface StudioAppearance {theme:'light'|'dark';accent:typeof STUDIO_ACCENTS[number];badge:typeof STUDIO_BADGES[number]}
export const DEFAULT_STUDIO_APPEARANCE:StudioAppearance={theme:'light',accent:'teal',badge:'diamond'};
